import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useLocation } from '@gatsbyjs/reach-router';
import { selectors as authSelectors } from '../../store/slices/authSlice';

import { ServiceFactory } from '../../services/ServiceFactory';

interface UseLatestSelection {
  url?: URL
}

/**
 *  Hook for fetching the most recent product selection url by customer
 */
export const useLatestSelection = (productKey: string): UseLatestSelection => {
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);
  const { host, protocol } = useLocation();
  const orderService = ServiceFactory.createOrderService();

  const { data } = useQuery({
    queryKey: ['latestSelectionUrl', productKey],
    queryFn: () => orderService.getLatestSelection(productKey),
    enabled: isLoggedIn,
  });

  if (data?.url) {
    const url = new URL(data.url);
    url.host = host;
    url.protocol = protocol;

    return { url };
  }

  return { url: undefined };
};
